import { render, staticRenderFns } from "./CardItem2.vue?vue&type=template&id=23b74566&scoped=true&"
import script from "./CardItem2.vue?vue&type=script&lang=js&"
export * from "./CardItem2.vue?vue&type=script&lang=js&"
import style0 from "./CardItem2.vue?vue&type=style&index=0&id=23b74566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b74566",
  null
  
)

export default component.exports